export class MonitoringService {
  public static init() {
    // TODO: Init some monitoring service like Sentry.
  }

  public static reportError(error: string) {} // eslint-disable-line @typescript-eslint/no-unused-vars

  public static reportLog(message: string) {} // eslint-disable-line @typescript-eslint/no-unused-vars
}
